import { Middleware } from 'redux';

const ResetSessionTimeout: Middleware = store => next => action => {
  localStorage.setItem('currentSessionTime', Date.now().toString());
  return next(action);
};

export default ResetSessionTimeout;
